module.exports = __webpack_public_path__ + "static/img/frame 8.2e46c128.png";